module.exports = __webpack_public_path__ + "static/media/trimex_seisaspas.c48f50e0.png";